module.exports = __webpack_public_path__ + "yt.7467851e5231c56c6007.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/yt.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/yt.svg
// module chunks = styles